// language=GraphQL
export const ALL_ACCOMMODATION_SERVICES_QUERY = `query Query($withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false) {
  accommodationServices: ratioAccommodationServices {
    id
    ratioServiceNo
    accommodation @include(if: $withAccommodation) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withAccommodationCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_ACCOMMODATION_SERVICE_QUERY = `query Query($id: ID!, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false) {
  accommodationService: ratioAccommodationService(id: $id) {
    id
    ratioServiceNo
    accommodation @include(if: $withAccommodation) {
      id
      ratioPackageNo
      name
      label
      info
      isFamilyPackageAccommodation
      isBabyPackage
      capacitySettings @include(if: $withAccommodationCapacitySettings) {
        id
        totalCapacity
        rangesAllowed
        ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
          id
          minCapacity
          maxCapacity
        }
        ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
          id
          capacity
        }
        partialOccupancyAllowed
        partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
          id
          name
          type
          icon
          minAge
          maxAge
        }
      }
      addons @include(if: $withAccommodationAddons) {
        id
        ratioServiceNo
        name
        label
        info
        calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
          id
          type
          considerHotelNights
        }
        mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
          id
          isMandatory
          useRules
          useDateSwitch
          useBusSettings
        }
      }
    }
  }
}`

// language=GraphQL
export const CREATE_ACCOMMODATION_SERVICE_MUTATION = `
  mutation Mutation($input: CreateRatioAccommodationServiceInput, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false) {
    accommodationService: createRatioAccommodationService(input: $input) {
      id
      ratioServiceNo
      accommodation @include(if: $withAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_ACCOMMODATION_SERVICE_MUTATION = `
  mutation Mutation($input: UpdateRatioAccommodationServiceInput, $withAccommodation: Boolean = false, $withAccommodationCapacitySettings: Boolean = false, $withAccommodationCapacitySettingsAgeGroupCapacities: Boolean = false, $withAccommodationCapacitySettingsAgeGroupedTotalCapacities: Boolean = false, $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups: Boolean = false, $withAccommodationAddons: Boolean = false, $withAccommodationAddonsCalculationSettings: Boolean = false, $withAccommodationAddonsMandatorySettings: Boolean = false) {
    accommodationService: updateRatioAccommodationService(input: $input) {
      id
      ratioServiceNo
      accommodation @include(if: $withAccommodation) {
        id
        ratioPackageNo
        name
        label
        info
        isFamilyPackageAccommodation
        isBabyPackage
        capacitySettings @include(if: $withAccommodationCapacitySettings) {
          id
          totalCapacity
          rangesAllowed
          ageGroupCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupCapacities) {
            id
            minCapacity
            maxCapacity
          }
          ageGroupedTotalCapacities @include(if: $withAccommodationCapacitySettingsAgeGroupedTotalCapacities) {
            id
            capacity
          }
          partialOccupancyAllowed
          partialOccupancyAllowedAgeGroups @include(if: $withAccommodationCapacitySettingsPartialOccupancyAllowedAgeGroups) {
            id
            name
            type
            icon
            minAge
            maxAge
          }
        }
        addons @include(if: $withAccommodationAddons) {
          id
          ratioServiceNo
          name
          label
          info
          calculationSettings @include(if: $withAccommodationAddonsCalculationSettings) {
            id
            type
            considerHotelNights
          }
          mandatorySettings @include(if: $withAccommodationAddonsMandatorySettings) {
            id
            isMandatory
            useRules
            useDateSwitch
            useBusSettings
          }
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_ACCOMMODATION_SERVICE_MUTATION = `
  mutation Mutation($input: DeleteRatioAccommodationServiceInput) {
    deleteRatioAccommodationService(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_ACCOMMODATION_SERVICE_MUTATION = `
  mutation Mutation($input: DeleteRatioAccommodationServiceInput) {
    forceDeleteRatioAccommodationService(input: $input) {
      success
    }
  }`
